import getDecorators from "inversify-inject-decorators";
import container from "../../../ioc/inversify.config";
import TYPES from "../../../ioc/types";
import { SocketEvents } from "../../../shared/enum";
import { GeometryService } from "../../ui-services/geometry-ui-service";
import { UIDialog } from "./shared-dialogs";
import { DialogBox } from "../../components/dialog-box";

const { lazyInject } = getDecorators(container);

export class BasicDialog implements UIDialog {
    @lazyInject(TYPES.GeometryService)
    protected geometryService: GeometryService;

    protected _callingScene: Phaser.Scene;

    protected dialog: Phaser.GameObjects.Container;
    private _dialogBox: DialogBox;

    constructor(scene: Phaser.Scene) {
        this._callingScene = scene;
        console.log(
            "constructing dialog scene with ",
            this._callingScene,
            ", world: ",
            this._callingScene.physics.world
        );
        this._dialogBox = new DialogBox(0, 0, "", this._callingScene);
    }

    public draw() {
        const graphics = this._callingScene.add.graphics();

        this.geometryService.initGraphicContext(graphics);

        console.log("calling scene physics: ", this._callingScene.physics.world);
        console.log("calling scene physics: ", this._callingScene.physics.world.bounds);
        const screenWidth = this._callingScene.physics.world.bounds.width;
        const screenHeight = this._callingScene.physics.world.bounds.height;

        this.geometryService.drawBox(2, screenHeight - 102, screenWidth - 4, 100);

        //@ts-ignore
        const dialog = this._callingScene.add.container();

        this._dialogBox.setPosition(5, screenHeight - 95);

        this.dialog = dialog.add(this._dialogBox);
    }

    public setText(text: string) {
        this._dialogBox.setText(text);
    }

    get dialogBox(): DialogBox {
        return this._dialogBox;
    }

    public onAction() {
        console.log("basic dialog on action, calling scene: ", this._callingScene);
        this._callingScene.events.emit(SocketEvents.PLAYER_ACTION);
    }
}
